export const styles = {
  dialogIcon: {
    height: 40,
    width: 40,
    color: 'text.secondary',
    '&:hover': {
      color: '#B72136',
    },
  },
  dialogButton: {
    my: 2,
  },
  avatar: {
    height: '75px',
    width: '75px',
  },
  infoBox: {
    bgcolor: 'background.paper',
    m: 1,
  },
  iconBox: {
    px: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 1,
  },
  formCard: {
    p: 3,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
    borderRadius: 2,
  },
  userInfoCard: {
    p: 3,
    bgcolor: 'background.paper',
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
    borderRadius: 2,
  },
  styleButton: {
    backgroundColor: '#2065D1',
    color: '#ffffff',
    '&:hover': {
      backgroundColor: '#2065B3',
      color: ' #ffffff',
    },
  },
  scrollableContainer: {
    maxHeight: '450px',
    overflowY: 'auto',
    overflowX: 'hidden',
    pr: 1,
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    // Using a semi-transparent slate grey thumb that looks great in both light and dark backgrounds
    '&::-webkit-scrollbar-thumb': {
      bgcolor: 'rgba(145, 158, 171, 0.4)',
      borderRadius: '10px',
    },
  },
  permCard: {
    p: 1.5,
    bgcolor: 'background.paper',
    borderRadius: 1.5,
    border: '1px solid',
    borderColor: 'divider',
    boxShadow: 'none',
  },
  categoryHeader: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 1,
    borderBottom: '1px solid',
    borderColor: 'divider',
    pb: 0.5,
    mb: 2,
  },
  categoryTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: 'text.primary',
    textTransform: 'uppercase',
  },
  categoryLabel: {
    fontSize: '0.85rem',
    fontWeight: 400,
    color: 'text.disabled',
  },
  permissionText: {
    fontSize: '0.81rem',
    fontWeight: 500,
    color: 'text.primary',
  },
  tabHeader: {
    display: 'flex',
    gap: 2,
    borderBottom: '1px solid',
    borderColor: 'divider',
    mb: 1,
  },
  tabButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    cursor: 'pointer',
    pb: 1,
    px: 1,
    transition: '0.3s',
    borderBottom: '2px solid transparent',
  },
  activeTab: {
    color: '#2065D1',
    borderBottom: '2px solid #2065D1',
  },
  arrowIcon: {
    fontSize: '1.2rem',
    transition: 'transform 0.3s',
    color: 'text.disabled',
  },
  arrowExpanded: {
    transform: 'rotate(180deg)',
  },
};

export const avatarDialogStyle = {
  dialogIcon: {
    color: 'text.secondary',
    '&:hover': {
      color: '#B72136',
    },
  },
  dialogButton: {
    mt: 2,
  },
};
